import { useEffect, useState } from 'react';

export const useClickedOutside = ref => {
  const [isClickedIn, setIsClickedIn] = useState(false);
  const windowClickHandler = e => setIsClickedIn(ref.current && !ref.current.contains(e.target));

  useEffect(() => {
    window.addEventListener('click', windowClickHandler, true);
    return () => window.removeEventListener('click', windowClickHandler, true);
  });

  return {
    isClickedIn
  };
};
